import i18next from 'i18next'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'

export default function tStatic(text: string): string {
  const { context }: CommonContextStore = useContextStore()

  return i18next.t(text, { ns: context.current_language.iso })
}
